import { api } from "@/api/api";
import { ApiUpsertCourseParticipantDto } from "@/api/generated/Api";
import { authService } from "@/auth/authService";

export const hasMemberOrgAccess = authService.fromMemberOrganization();

const memberOrganizationApi = {
  getCourse: api.guestside.getGuestUserCourseByIdFilteredByOrganizationAsync,
  getCourses: api.guestside.getGuestUserCoursList,
  getCurriculum: api.guestside.getGuestUserCurriculumAsync,
  getExecutionPlan: api.guestside.getGuestUserExecutionPlanAsync,
  getCourseParticipants: api.guestside.getGuestUserCourseParticipantsByCourseIdAsync,
  getAreaById: api.guestside.getGuestUserAreaByIdAsync,
  getMemberOrganizations: api.guestside.getGuestUserMemberOrganizations,
  getCustomerPerson: api.guestside.getGuestUserCustomerPersonByIdAsync,
  getCustomerPersons: api.guestside.getGuestUserCustomerPersonsAsync,
  getDefaultOptions: api.guestside.getGuestUserCourseDefaultOptions,
  getAppFormTemplate: api.guestside.getGuestUserAppFormTemplateAsync,
  getAppFormResponse: api.guestside.getGuestCourseParticipantAppFormResponse,
  getParticipantAttendance: api.guestside.getCourseParticipantAttendances,
  getCourseApplications: api.guestDashboard.getCourseApplications,
  getSectors: api.sectors.getSectorsAsync,
  getCourseParticipantStatusesAsync: api.course.getCourseParticipantStatusesAsync,
  getActivatedOrganizationFeatureSettings: api.guestside.getActivatedOrganizationFeatureSettings1,
  upsertCourseParticipant: (courseId: number, payload: ApiUpsertCourseParticipantDto, userId: number) => {
    if (!payload.memberOrganizationId) {
      return;
    }
    return api.guestside.changeGuestUserCourseParticipantApplicationStatus(courseId, userId, {
      participantStatus: payload.status,
      memberOrganizationId: payload.memberOrganizationId,
      sectorId: payload.sectorId,
    });
  },
};

const unrestrictedApi = {
  getCourse: api.course.getCourseByIdFilteredByDepartmentAsync,
  getCourses: api.course.getCourseList,
  getCurriculum: api.curriculum.getCurriculumAsync,
  getExecutionPlan: api.curriculum.getExecutionPlanAsync,
  getCourseParticipants: api.course.getCourseParticipantsByCourseIdAsync,
  getAreaById: api.area.getAreaByIdAsync,
  getMemberOrganizations: api.organization.getMemberOrganizationsAsync,
  getCustomerPerson: api.customer.getCustomerPersonByIdAsync,
  getCustomerPersons: api.customer.getCustomerPersonsAsync,
  getDefaultOptions: api.course.getCourseDefaultOptions,
  getAppFormTemplate: api.appformtemplate.getAppFormTemplateAsync,
  getAppFormResponse: api.course.getAppFormResponseAsync,
  getParticipantAttendance: api.course.getCourseParticipantAttendancesByCourseIdAsync,
  getCourseApplications: api.dashboard.getUnreadCourseApplications,
  getSectors: api.sectors.getSectorsAsync,
  getCourseParticipantStatusesAsync: api.course.getCourseParticipantStatusesAsync,
  getActivatedOrganizationFeatureSettings: api.organization.getActivatedOrganizationFeatureSettings,
  upsertCourseParticipant: (courseId: number, payload: ApiUpsertCourseParticipantDto) =>
    api.course.upsertCourseParticipantAsync(courseId, payload),
};

export const useRestrictedAccessApi = () => {
  if (authService.fromMemberOrganization()) {
    return memberOrganizationApi;
  }
  return unrestrictedApi;
};
